import { render } from "./SendOrderDialog.vue?vue&type=template&id=2dff40ea&ts=true"
import script from "./SendOrderDialog.vue?vue&type=script&lang=ts"
export * from "./SendOrderDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__